import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { ErrorState } from './state';
import { ErrorType } from './action';

export const initialState: ErrorState = { error: null };

export const errorReducer = (state: ErrorState | undefined, action: Action): ErrorState => {
    state = state ?? initialState;

    switch (action.type) {
        case ErrorType.HasBeenThrown:
            return { ...state, error: action.error };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
